import { getDashboard, getDashboardStatistic } from "services/apis/dashborad";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doGetDashboard = createAsyncThunk(
  "dashboard/doGetDashboard",
  async () => {
    const result = await getDashboard();
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const doGetDashboardStatistic = createAsyncThunk(
  "dashboard/doGetDashboardStatistic",
  async () => {
    const result = await getDashboardStatistic();
    if (!result) {
      return;
    }
    return result.data;
  }
);
const initialState = {
  data: {},
};

const slice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
  },
  extraReducers: {
    [doGetDashboard.fulfilled]: (state, actions) => {
      state.data = actions?.payload;
    },
  },
});

const { reducer } = slice;

export default reducer;

export const isSaving = createSelector(
  state => state.customFields.isSaving,
  isSaving => isSaving
);

export const getAllCustomField = createSelector(
  state => state.customFields.allCustomFields,
  allCustomFields => allCustomFields
);

export const numOfEls = createSelector(
  state => state.customFields.numberOfElements,
  numberOfElements => numberOfElements
);
